import { render, staticRenderFns } from "./VotingRegistrationAutoMatchDetails.vue?vue&type=template&id=4f0c265b&"
import script from "./VotingRegistrationAutoMatchDetails.vue?vue&type=script&lang=js&"
export * from "./VotingRegistrationAutoMatchDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports